import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes';
import i18n from './i18n'
// import Axios from 'axios';


Vue.config.productionTip = false;


Vue.use(VueRouter);
Vue.use(VueI18n);
// Vue.use(Axios);

const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
